export default "__VITE_ASSET__CqnEW9$2__"